import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormControlWrapper } from '../../../styles';
import { IListItem } from '@nkr/models/index';

interface IProps {
    show: boolean,
    donorStatus: number,
    pairStatusList: IListItem[],
    onDonorStatusChange: (donorStatus: number) => void,
    onSave: () => void,
    onCancel: () => void
}

class DonorStatus extends React.Component<IProps, {}> {
    handleDonorStatusChange = (e: React.FormEvent<any>) => {
        this.props.onDonorStatusChange(parseInt(e.currentTarget.value));
    }

    handleSave = () => {
        this.props.onSave();
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    render = () => {
        return (
            <Modal show={this.props.show} onHide={() => null}>
                <Modal.Header>
                    <Modal.Title>Update Donor Status</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ marginBottom: 20 }}>You have changed the Pair Status away from TRANSPLANTED, which requires that you also set the donor's status...</div>

                    <div>
                        <FormControlWrapper
                            componentClass="select"
                            style={{ width: 200 }}
                            value={this.props.donorStatus}
                            onChange={this.handleDonorStatusChange}
                        >
                            {this.props.pairStatusList.map((item, index) =>
                                <option key={index} value={item.id}>{item.description}</option>
                            )}
                        </FormControlWrapper>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle="primary" onClick={this.handleSave}>Update Donor Status</Button>
                    <Button onClick={this.handleCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default DonorStatus;